import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = () => (_jsxs("svg", { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", viewBox: "0 0 24 24", children: [_jsx("circle", { cx: 12, cy: 12, r: 10 }), _jsx("path", { d: "M12 16v-4M12 8h.01" })] }));
export default SvgComponent;
